@if (visible && state) {
<div class="huge-sync-wrapper u-slow-appear">
  <!-- close -->
  <button type="button" class="huge-sync-close btn btn-light btn-sm" (click)="visible = false">
    <i class="fa fa-close"></i>
  </button>
  <!-- sync button -->
  <button type="button" class="huge-sync-btn" [ngClass]="stateClasses[state].border" (click)="clicked.emit()">
    <div>
      @if (state !== 'disabled') {
      <i class="fa fa-refresh"></i>
      } @if (state === 'disabled') {
      <i class="fa fa-ban"></i>
      }
    </div>
  </button>
  <!-- badge -->
  @if (hasRowCount || hasCellCount) {
  <div
    class="badge mt-3 text-white"
    [class.u-cursor-pointer]="hasCellAndRowCount()"
    [ngClass]="stateClasses[state].badge"
    (click)="onBadgeClick()">
    @if (!pers.displayCellCount && rowCount > -1) {
    <span>{{ 'ROWS' | agrTranslate }}: {{ rowCount | agrFormat: 'integer' }}</span>
    } @if (pers.displayCellCount && cellCount > -1) {
    <span>{{ 'CELLS' | agrTranslate }}: {{ cellCount | agrFormat: 'integer' }}</span>
    }
  </div>
  }
</div>
}
